<template>
    <div v-wechat-title="title">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: `Scheduling`,
    props: {
    },
    data() {
        return {
            title: `排程`
        }
    }
}
</script>
<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/Index.vue